/**
 * @generated SignedSource<<813d8201dc7e37a145f114e5898f09af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FeatureFlagProviderQuery$variables = {
  orgUuid: string;
};
export type FeatureFlagProviderQuery$data = {
  readonly organization: {
    readonly featureFlags: {
      readonly apiObservability: boolean;
      readonly cloudRel3UiUpdates: boolean;
      readonly cloudRel4UiUpdates: boolean;
      readonly cloudRel5UiUpdates: boolean;
      readonly customMapLayersExternal: boolean;
      readonly dfrCommand: boolean;
      readonly enableAxonWatchMeDemo: boolean;
      readonly enableCreateMarkerInteractionRfd: boolean;
      readonly enableDfrCommandPhaseThreeUi: boolean;
      readonly enableDfrCommandPhaseTwoPointFiveUi: boolean;
      readonly enableDfrCommandPhaseTwoUi: boolean;
      readonly enableDfrDockviewLayout: boolean;
      readonly enableDfrOutcomesSurvey: boolean;
      readonly enableDispatchRespondHere: boolean;
      readonly enableDocklessSites: boolean;
      readonly enableIncidentsStateUi: boolean;
      readonly enableLookAtFinalPoint: boolean;
      readonly enableManualIncidentCreation: boolean;
      readonly enableMultidroneOperations: boolean;
      readonly enablePlanningAroundGeofencesFlyToPointRfd: boolean;
      readonly enablePostFlightReports: boolean;
      readonly enableRfdDedrone: boolean;
      readonly enableRfdViewLookatPoint: boolean;
      readonly enableStandoffDistance: boolean;
      readonly externalApiIncidentMarkersUi: boolean;
      readonly filterMarkerButtonInSidebar: boolean;
      readonly filterMarkersInRfdSidebar: boolean;
      readonly markersApi: boolean;
      readonly multizoneSiteGeofences: boolean;
      readonly safeLandingPoints: boolean;
      readonly sortDroneSelectionModalDispatch: boolean;
      readonly usePathfinderFlyToPointRfd: boolean;
    } | null;
    readonly id: string;
  } | null;
};
export type FeatureFlagProviderQuery = {
  response: FeatureFlagProviderQuery$data;
  variables: FeatureFlagProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgUuid"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "uuid",
        "variableName": "orgUuid"
      }
    ],
    "concreteType": "Organization",
    "kind": "LinkedField",
    "name": "organization",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FeatureFlags",
        "kind": "LinkedField",
        "name": "featureFlags",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dfrCommand",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableMultidroneOperations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableRfdDedrone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDfrCommandPhaseTwoUi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDfrCommandPhaseTwoPointFiveUi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDfrCommandPhaseThreeUi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalApiIncidentMarkersUi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "filterMarkersInRfdSidebar",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDfrDockviewLayout",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customMapLayersExternal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cloudRel3UiUpdates",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableStandoffDistance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableLookAtFinalPoint",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableCreateMarkerInteractionRfd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDocklessSites",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "multizoneSiteGeofences",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "safeLandingPoints",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDispatchRespondHere",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "markersApi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableManualIncidentCreation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableIncidentsStateUi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableAxonWatchMeDemo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sortDroneSelectionModalDispatch",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cloudRel4UiUpdates",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enablePostFlightReports",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cloudRel5UiUpdates",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDfrOutcomesSurvey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enablePlanningAroundGeofencesFlyToPointRfd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "usePathfinderFlyToPointRfd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "apiObservability",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "filterMarkerButtonInSidebar",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableRfdViewLookatPoint",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeatureFlagProviderQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeatureFlagProviderQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "921e8e316b71af9a265efa1730a77908",
    "id": null,
    "metadata": {},
    "name": "FeatureFlagProviderQuery",
    "operationKind": "query",
    "text": "query FeatureFlagProviderQuery(\n  $orgUuid: String!\n) {\n  organization(uuid: $orgUuid) {\n    id\n    featureFlags {\n      dfrCommand\n      enableMultidroneOperations\n      enableRfdDedrone\n      enableDfrCommandPhaseTwoUi\n      enableDfrCommandPhaseTwoPointFiveUi\n      enableDfrCommandPhaseThreeUi\n      externalApiIncidentMarkersUi\n      filterMarkersInRfdSidebar\n      enableDfrDockviewLayout\n      customMapLayersExternal\n      cloudRel3UiUpdates\n      enableStandoffDistance\n      enableLookAtFinalPoint\n      enableCreateMarkerInteractionRfd\n      enableDocklessSites\n      multizoneSiteGeofences\n      safeLandingPoints\n      enableDispatchRespondHere\n      markersApi\n      enableManualIncidentCreation\n      enableIncidentsStateUi\n      enableAxonWatchMeDemo\n      sortDroneSelectionModalDispatch\n      cloudRel4UiUpdates\n      enablePostFlightReports\n      cloudRel5UiUpdates\n      enableDfrOutcomesSurvey\n      enablePlanningAroundGeofencesFlyToPointRfd\n      usePathfinderFlyToPointRfd\n      apiObservability\n      filterMarkerButtonInSidebar\n      enableRfdViewLookatPoint\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "420ce7d54be8419774c720de188da38a";

export default node;
